/**
 * Yield the main thread so the browser can paint / handle input before
 * continuing heavy work (INP). Prefer `scheduler.yield` when available.
 */
export function yieldToMain(): Promise<void> {
  const scheduler = (
    globalThis as typeof globalThis & {
      scheduler?: { yield?: () => Promise<void> };
    }
  ).scheduler;

  if (typeof scheduler?.yield === 'function') {
    return scheduler.yield();
  }

  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}
